class Sorting {
}
class BlockAttribute {
}
var PageTypeEnum;
(function (PageTypeEnum) {
    PageTypeEnum["HOME"] = "PAGE_TYPE_HOME";
    PageTypeEnum["CATEGORY"] = "PAGE_TYPE_CATEGORY";
    PageTypeEnum["NOTIFICATION"] = "PAGE_TYPE_NOTIFICATION";
    PageTypeEnum["SELLER"] = "PAGE_TYPE_SELLER";
    PageTypeEnum["BRAND"] = "PAGE_TYPE_BRAND";
})(PageTypeEnum || (PageTypeEnum = {}));

export { BlockAttribute, PageTypeEnum, Sorting };
